import { render, staticRenderFns } from "./DetailsBasicFertilizationPlannedYield.vue?vue&type=template&id=2c19974d&scoped=true&"
import script from "./DetailsBasicFertilizationPlannedYield.vue?vue&type=script&lang=js&"
export * from "./DetailsBasicFertilizationPlannedYield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c19974d",
  null
  
)

export default component.exports